export default {
  title: 'Prescribing physician information',
  titleDescription: 'Complete the following information to continue',
  nameLabel: 'Name and Lastname',
  specialtyLabel: 'Specialty',
  license: 'License',
  countryLabel: 'Country code',
  providerCode: 'Provider code',
  doctorTitle: "Prescribing physician data",
  doctorDescription:"Enter the following information",
  diagnosesTitle: "Diagnoses",
  productsTitle: "Products",
  prescriptionTitle: "Prescription",
  prescriptionDescription: "Files in PDF, PNG or JPEG format, maximum size 20Mb",
  buttons: {
    add: "Add"
  },
  noFiles: "No files attached",
  sponsorProduct: {
    title: "Outpatient care information",
    subtitle: "Choose the type of outpatient care",
    label: "Type of outpatient care"
  },
  validations: {
    prescription: "Enter the doctor's details.",
    diagnoses: "Add at least one diagnosis.",
    treatments: "Add at least one product.",
    receiptFile: "Add recipe / indication file.",
    requiredField: "Please enter all required fields."
  }
}